import { defineStore } from "pinia";
import axios from "axios";
import { apiAction } from "@/store/helpers.js";
import { ACCOUNT_ENDPOINTS } from "@/api/account.endpoints.js";

export const useAccountProductStore = defineStore("accountProduct", {
  state: () => ({
    isLoading: false,
    error: null,
  }),

  actions: {
    async editDesign(payload) {
      return apiAction(this, () => axios.post(ACCOUNT_ENDPOINTS.editDesign, payload));
    },

    async editMockup(payload) {
      return apiAction(this, () => axios.post(ACCOUNT_ENDPOINTS.editMockup, payload));
    },

    async editPricing(variants) {
      return apiAction(this, () => axios.post(ACCOUNT_ENDPOINTS.editPricing, { variants }));
    },

    async deleteProduct(productId) {
      return apiAction(this, () => axios.post(ACCOUNT_ENDPOINTS.deleteProduct, { product: { id: productId } }));
    },

    async changePublishing(productId, isPublished) {
      return apiAction(this, () => axios.post(ACCOUNT_ENDPOINTS.changePublishingStatus, { product: { id: productId, isPublished } }));
    },

    async changeListing(productId, isListed) {
      return apiAction(this, () => axios.post(ACCOUNT_ENDPOINTS.changeListingStatus, { product: { id: productId, isListed } }));
    },

    async changeSalesVisible(productId, isSalesVisible) {
      return apiAction(this, () => axios.post(ACCOUNT_ENDPOINTS.changeSalesVisibleStatus, { product: { id: productId, isSalesVisible } }));
    },

    async changeFeatured(productId, isStoreFeatured) {
      return apiAction(this, () => axios.post(ACCOUNT_ENDPOINTS.changeFeaturedStatus, { product: { id: productId, isStoreFeatured } }));
    },

    async generateMockupArchive(productId) {
      return apiAction(this, () => axios.post(ACCOUNT_ENDPOINTS.generateMockupArchive, { productId }));
    },
  },
});
